// /eventpage route — stays forever, never 404s
import { Navigate } from "react-router-dom";

const EventPageRedirect = () => {
  // update this one line whenever the "current" event changes
  return <Navigate to="/events/Christmas" replace />;
};
export default EventPageRedirect;
